var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconContentAggregation = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-234.917 -325.917)" },
                React.createElement("path", { d: "M253.2,334.4c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3S253.2,332.6,253.2,334.4z" }),
                React.createElement("path", { d: "M249.9,337.7v7.5" }),
                React.createElement("path", { d: "M240.9,345.9v-1.1c0-1.2,1-2.2,2.2-2.2h6.5" }),
                React.createElement("path", { d: "M252.2,348.4c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3s1-2.3,2.3-2.3S252.2,347.2,252.2,348.4z" }),
                React.createElement("path", { d: "M261.2,348.4c0,1.2-1,2.3-2.3,2.3c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3\n\t\tC260.2,346.2,261.2,347.2,261.2,348.4z" }),
                React.createElement("path", { d: "M243.2,348.4c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3s1-2.3,2.3-2.3S243.2,347.2,243.2,348.4z" }),
                React.createElement("path", { d: "M258.9,345.9v-1.1c0-1.2-1-2.2-2.2-2.2h-6.5" })))));
});
export default IconContentAggregation;
//# sourceMappingURL=IconContentAggregation.js.map